import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { Button, ModalDefault, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { escapeHtml } from "@components/ow";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ACTIONS = {
  rotate: {
    title: "Rotacionar chave?",
    question: "Gerar nova chave para <strong>%s</strong>?",
    text: "A chave atual será revogada e uma nova será gerada com o mesmo nome, escopo e validade. Sistemas que usam a chave atual precisarão ser atualizados.",
    button: "Rotacionar chave",
    variant: "primary",
  },
  revoke: {
    title: "Revogar chave?",
    question: "Revogar a chave <strong>%s</strong>?",
    text: "Sistemas que usam esta chave deixarão de ter acesso imediatamente. A revogação não tem volta.",
    button: "Revogar chave",
    variant: "danger",
  },
};

/**
 * Confirma rotacionar ou revogar (`mode`). `onDone(plaintext)`: a chave nova, na rotação.
 * Em erro, o sendError do service mostra o toast e o modal fica aberto.
 */
export default function ApiKeyActionModal({ mode, apiKey, onClose, onDone }) {
  const apiKeysService = useService("apiKeys");
  const [loading, setLoading] = useState(false);
  const action = ACTIONS[mode];

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    const result = await apiKeysService[mode](apiKey.id);
    setLoading(false);
    if (!result || result.error) return;
    if (mode === "revoke") toast.success("Chave revogada");
    onDone(result.data?.plaintext);
  }

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title={action.title}
      $contentBackground="N0"
      $footer={
        <>
          <Button $text="Cancelar" $variant="outline" $action={close} $isDisabled={loading} $noWidth />
          <Button $text={action.button} $variant={action.variant} $action={confirm} $isLoading={loading} $noWidth />
        </>
      }
    >
      <Body>
        <Text
          $text={action.question}
          $replaces={[escapeHtml(apiKey.name)]}
          $variant="paragraph_small_medium"
          $color="N900"
          $colorEmphasis="N900"
        />
        <Text $text={action.text} $variant="paragraph_small_medium" $color="N700" />
      </Body>
    </ModalDefault>
  );
}
